const UI_TO_API_ROLE = {
  FM: "fleetmanager",
  TSI: "superintendent",
  TE: "technicalexecutive",
};

const API_TO_UI_ROLE = {
  fleetmanager: "FM",
  superintendent: "TSI",
  technicalexecutive: "TE",
};

export const uiRoleToApi = (role) => {
  if (!role) {
    return "";
  }
  return UI_TO_API_ROLE[role] || role.toLowerCase();
};

export const apiRoleToUi = (roleName) => {
  if (!roleName) {
    return "";
  }
  const normalized = roleName.toLowerCase().trim();
  return API_TO_UI_ROLE[normalized] || roleName;
};

export const mapClientUserFromApi = (item) => ({
  id: item.clientUsersMasterId,
  clientUsersMasterId: item.clientUsersMasterId,
  name: item.name,
  email: item.email,
  phone: item.phone,
  address: item.address,
  role: apiRoleToUi(item.roleName),
  roleName: item.roleName,
});
